import React, { useEffect, useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { db } from 'MY_LOGIN_AND_SIGNUP/db/config';
import { useNavigate } from 'react-router-dom';

const data = [
  { id: 1, name: 'Alice', age: 25, city: 'New York' },
  { id: 2, name: 'Bob', age: 30, city: 'Los Angeles' },
  { id: 3, name: 'Charlie', age: 28, city: 'Chicago' },
  { id: 4, name: 'David', age: 35, city: 'Houston' },
];

const AttemptedUserList = ({ attemptedUserListState, handleClose }) => {
  const [studentList, setStudentList] = useState([]);

  const navigate = useNavigate();

  const fetchAttemptedUserList = async (quizTestId) => {
    try {
      const assignedQuizTestsSnapshot = await db
        .collection('attemptedQuizTest')
        .where('quizTestId', '==', quizTestId)
        .orderBy('createdAt', 'desc')
        .get();
      console.log(attemptedUserListState, quizTestId, 'AttemptedUserList');

      if (assignedQuizTestsSnapshot.empty) {
        console.log('assignedQuizTestsSnapshot failed', 'AttemptedUserList');
        return [];
      }

      const assignedQuizTests = assignedQuizTestsSnapshot.docs.map(
        (doc, i) => ({
          id: doc.id,
          ...doc.data(),
        })
      );

      console.log(assignedQuizTests, 'assignedQuizTests');
      const quizTestSnapshot = await db
        .collection('QuizTest')
        .doc(quizTestId)
        .get();

      if (!quizTestSnapshot.exists) {
        console.log(`QuizTest with id ${quizTestId} not found`);
        return null;
      }

      const quizTestData = {
        id: quizTestSnapshot.id,
        ...quizTestSnapshot.data(),
      };

      const userIds = assignedQuizTests.map((test) => test.userId);

      if (userIds.length === 0) {
        console.log(
          'No user IDs found in assigned quiz tests.',
          'AttemptedUserList'
        );
        return [];
      }

      const studentsSnapshot = await db
        .collection('zSystemStudents')
        .where('userID', 'in', userIds)
        .orderBy('firstname', 'asc')
        .get();

      if (studentsSnapshot.empty) {
        console.log(
          'No students found for the given user IDs.',
          'AttemptedUserList'
        );
        return assignedQuizTests;
      }

      const studentsMap = new Map();
      const orderedStudents = [];

      // Loop through studentsSnapshot in order and store in a constant array
      studentsSnapshot.docs.forEach((doc) => {
        const studentData = {
          userID: doc.data().userID,
          firstName: doc.data().firstname,
          lastName: doc.data().lastname,
        };
        studentsMap.set(studentData.userID, studentData);
        orderedStudents.push(studentData.userID); // Maintain the original student order
      });

      // Create an array to store final results
      const enrichedQuizTests = [];

      // Loop through students in order and add quiz test attempts
      orderedStudents.forEach((userID) => {
        // Get total attempts for this user
        const totalAttempts = assignedQuizTests.filter(
          (test) => test.userId === userID
        ).length;
        let attempt = totalAttempts; // Start from the highest attempt count

        assignedQuizTests.forEach((test) => {
          if (test.userId === userID) {
            enrichedQuizTests.push({
              ...test,
              negativeMarks: quizTestData.negativeMarks,
              postiveMarks: quizTestData.positiveMarks,
              attempt, // Assign attempt in descending order
              studentData: studentsMap.get(userID) || null,
            });
            attempt--; // Decrease attempt count for next entry
          }
        });
      });

      console.log('AttemptedUserList', 'enrichedQuizTests', enrichedQuizTests);
      setStudentList(enrichedQuizTests);
    } catch (error) {
      console.error('Error fetching assigned quiz students:', error);
      throw error;
    }
  };

  const handleNavigateToReport = (id, userName, quizName) => {
    const queryParams = new URLSearchParams({
      id: id,
    }).toString();

    let stateData = { userName, quizName };
    navigate(`/admin/quiz-report?${queryParams}`, { state: stateData });
  };

  useEffect(() => {
    // if (attemptedUserListState?.quizId) {
    fetchAttemptedUserList(attemptedUserListState?.quizId);
    // }
  }, [attemptedUserListState]);

  return (
    <div>
      <Modal
        open={attemptedUserListState.isOpen}
        onClose={() => {
          setStudentList([]);
          handleClose();
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '50vw',
            bgcolor: '#26293C',
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
            maxHeight: '80vh',
            overflowY: 'auto',
          }}
        >
          <Box
            display='flex'
            justifyContent='space-between'
            alignItems='center'
            mb={2}
          >
            <Typography sx={{ fontSize: '18px' }} variant='h6'>
              {attemptedUserListState?.quizName}
            </Typography>
            <Close onClick={handleClose} style={{ cursor: 'pointer' }} />
          </Box>

          <TableContainer sx={{ background: '#26293C' }} component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ color: 'white' }}>Student Name</TableCell>
                  <TableCell style={{ color: 'white', textAlign: 'center' }}>
                    Last Attempted
                  </TableCell>
                  <TableCell style={{ color: 'white', textAlign: 'center' }}>
                    Attempt
                  </TableCell>
                  <TableCell style={{ color: 'white', textAlign: 'center' }}>
                    Marks
                  </TableCell>
                  <TableCell style={{ color: 'white', textAlign: 'center' }}>
                    Report
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {studentList?.length === 0 &&
                  [0, 1, 2, 3]?.map((item) => (
                    <TableRow key={item}>
                      <TableCell style={{ color: 'white' }}>
                        <div
                          style={{
                            width: '100px',
                            height: '25px',
                            background: 'rgba(0,0,0,0.4)',
                          }}
                        ></div>
                      </TableCell>

                      <TableCell
                        style={{ color: 'white', textAlign: 'center' }}
                      >
                        <div
                          style={{
                            width: '100px',
                            height: '25px',
                            background: 'rgba(0,0,0,0.4)',
                            margin: '0 auto',
                          }}
                        ></div>
                      </TableCell>
                      <TableCell
                        style={{ color: 'white', textAlign: 'center' }}
                      >
                        <div
                          style={{
                            width: '100px',
                            height: '25px',
                            background: 'rgba(0,0,0,0.4)',
                            margin: '0 auto',
                          }}
                        ></div>
                      </TableCell>
                      <TableCell
                        style={{ color: 'white', textAlign: 'center' }}
                      >
                        <div
                          style={{
                            width: '100px',
                            height: '25px',
                            background: 'rgba(0,0,0,0.4)',
                            margin: '0 auto',
                          }}
                        ></div>
                      </TableCell>
                      <TableCell
                        style={{ color: 'white', textAlign: 'center' }}
                      >
                        <div
                          style={{
                            width: '100px',
                            height: '25px',
                            background: 'rgba(0,0,0,0.4)',
                            margin: '0 auto',
                          }}
                        ></div>
                      </TableCell>
                    </TableRow>
                  ))}
                {studentList?.length > 0 &&
                  studentList?.map((row) => (
                    <TableRow key={row.userId}>
                      <TableCell style={{ color: 'white' }}>
                        {row?.studentData?.firstName +
                          row?.studentData?.lastName}
                      </TableCell>

                      <TableCell
                        style={{ color: 'white', textAlign: 'center' }}
                      >
                        {new Date(
                          row?.createdAt?.seconds * 1000
                        )?.toLocaleString()}
                      </TableCell>
                      <TableCell
                        style={{ color: 'white', textAlign: 'center' }}
                      >
                        {row?.attempt}
                      </TableCell>
                      <TableCell
                        style={{ color: 'white', textAlign: 'center' }}
                      >
                        {console.log(row, "itemitemitemitemitem")}

                        {row?.isCorrect !== undefined &&
                        row?.postiveMarks!== undefined &&
                        row?.isWrongAns !== undefined &&
                        row?.negativeMarks !== undefined
                          ? row?.isCorrect * row?.postiveMarks -
                            row?.isWrongAns * row?.negativeMarks +
                            '/' +
                          (row?.isCorrect + row?.isNotAnswered + row.isWrongAns) * row?.postiveMarks
                          : 'N/N'}
                      </TableCell>
                      <TableCell
                        style={{ color: 'white', textAlign: 'center' }}
                      >
                        <Button
                          onClick={() =>
                            handleNavigateToReport(
                              row?.id,
                              ` ${row?.studentData?.firstName}   
                                ${row?.studentData?.lastName}`,
                              attemptedUserListState?.quizName
                            )
                          }
                          type='button'
                          variant='contained'
                          color='info'
                        >
                          Report
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Modal>
    </div>
  );
};

export default AttemptedUserList;
